var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9131 9.11898C23.2552 8.06604 24.7448 8.06605 25.0869 9.11897L27.4506 16.3935C27.8331 17.5708 28.9301 18.3678 30.1679 18.3678H37.8168C38.9239 18.3678 39.3842 19.7845 38.4886 20.4352L32.3005 24.9312C31.2991 25.6587 30.88 26.9483 31.2625 28.1256L33.6262 35.4001C33.9683 36.4531 32.7632 37.3286 31.8675 36.6779L25.6794 32.1819C24.678 31.4544 23.322 31.4544 22.3206 32.1819L16.1325 36.6779C15.2368 37.3286 14.0317 36.453 14.3738 35.4001L16.7375 28.1256C17.12 26.9483 16.7009 25.6587 15.6995 24.9312L9.51143 20.4352C8.61575 19.7845 9.07607 18.3678 10.1832 18.3678H17.8321C19.0699 18.3678 20.1669 17.5708 20.5494 16.3935L22.9131 9.11898Z",
    stroke: "#FFCC00",
    strokeWidth: 1.71429
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "static/media/rate.9fd80d40f69472f6786d624d374c18d8.svg";
export { ForwardRef as ReactComponent };